<template>
  <div>
    <v-card
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      :class="{ 'grey lighten-2': dragover }"
    >
      <v-card-text>
        <v-row class="d-flex flex-column" dense align="center" justify="center">
          <span class="content-container">
            <v-icon>mdi-cloud-upload</v-icon>
            <span class="ml-3" style="font-size: 20px">Drag and drop or</span>
            <v-btn
              class="ml-3"
              color="primary"
              dark
              @click="handleFileImport"
            >
              SELECT FROM YOUR COMPUTER
            </v-btn>
            <input
              id="file-input"
              ref="uploader"
              class="d-none"
              type="file"
              @change="onFileChanged"
              multiple
              :accept="acceptedFileTypes"
            />
          </span>
        </v-row>
      </v-card-text>
    </v-card>
    <div v-if="uploadedFiles.length > 0">
      <v-card-title>
        Uploaded files
        <v-spacer></v-spacer>
        <v-btn depressed small color="primary" @click="uploadedFiles = []"
          >Clear</v-btn
        >
      </v-card-title>
      <v-simple-table
        fixed-header
        :height="tableHeight"
        :search="search"
        class="files-table"
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 10px"></th>
              <th class="text-left" style="width: 200px">Name</th>
              <th class="text-left" style="width: 100px; color: #90a4ae">
                Size
              </th>
              <th class="text-left" style="width: 150px" v-if="!supportingOnly">Main Document</th>
              <th class="text-right" style="width: 200px">
                <v-text-field
                  placeholder="Search"
                  filled
                  rounded
                  dense
                  v-model="search"
                ></v-text-field>
              </th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="(item, index) in filteredFiles" :key="index">
              <td><DocumentTypeIcon :type="item.file_type"/></td>
              <td>{{ shortText(item.file.name) }}</td>
              <td style="color: #90a4ae">{{ formatBytes(item.file.size) }}</td>
              <td v-if="!supportingOnly"><v-switch v-model="item.isMainDocument" @click="updateMainDocument(index)"></v-switch></td>
              <td class="text-right">
                <v-btn depressed small color="primary" @click="previewImage(item.url)" :disabled="item.file_type !== `image`">PREVIEW</v-btn>
                <v-btn @click.stop="removeFile(item.file.name)" icon>
                  <v-icon> mdi-close-circle </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-subtitle>Total: {{uploadedFiles.length}} file/s uploaded</v-card-subtitle>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <ImageViewer :dialog="viewImage" :url="object_url" @closeDialog="closeImageView"/>
  </div>
</template>

<script>
import DocumentTypeIcon from "../../common/DocumentTypeIcon.vue"
import ImageViewer from "../modal/ImageViewer.vue"
export default {
  name: "Uploader",
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    supportingOnly: {
      type: Boolean,
      default: false,
    },
    doneUploading: {
      type: Boolean, 
      default: false,
    }
  },
  components: {
      DocumentTypeIcon,
      ImageViewer
  },
  data() {
    return {
      dragover: false,
      uploadedFiles: [],
      search: null,
      selectedFile: null,
      viewImage: false,
      object_url: null,
      acceptedFileTypes: ".png, .jpg , .jpeg, .doc, .docx, .docm, .pdf, .txt, .xls, .xlsb, .xlsm, .xlsx, .ppt, .pptx",
      snackbar: false,
      text: 'My timeout is set to 2000.',
      timeout: 2000,  
      countNotAllowedFiles: 0
    };
  },
  methods: {
    previewImage(url) {
        this.object_url = url
        this.viewImage = true
    },
    closeImageView(val) {
        this.viewImage = val
    },
    updateMainDocument(index){
        //used to trigger change when updating a key value in the array
        this.uploadedFiles.forEach((item, idx) => {
            if(idx !== index)
                item.isMainDocument = false
        })
        let temp = this.uploadedFiles
        this.uploadedFiles = []
        this.uploadedFiles = temp
    },
    onDrop(e) {
      this.dragover = false;
      if (!this.multiple && e.dataTransfer.files.length > 1) {
        alert("only one file is allowed");
      } else
        e.dataTransfer.files.forEach((element) => {
            let file_type=""
            let url = null
            let inputFileType = element.name.substr(element.name.indexOf('.') + 1);
            let isAllowed = this.acceptedFileTypes.includes(inputFileType)
            url = URL.createObjectURL(element)
            if (element.type.includes("image")) file_type = "image";
            else if (element.type.includes("pdf")) file_type = "pdf";
            else if (element.type.includes("word")) file_type = "word";
            else if (element.type.includes("sheet")) file_type = "sheet";
            else file_type = "file";
            if(!isAllowed)
              this.countNotAllowedFiles +=1
            else
              this.uploadedFiles.push({url, file_type, isMainDocument: false, file: element})

            if(this.countNotAllowedFiles > 0){
              this.text = `${this.countNotAllowedFiles} file/s was not added. File type not allowed.`
              this.snackbar = true
            }
          }
        );
    },
    removeFile(fileName) {
      const index = this.uploadedFiles.findIndex(
        (file) => file.file.name === fileName
      );
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
    },
    formatBytes(x) {
      const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      let l = 0,
        n = parseInt(x, 10) || 0;
      0;
      while (n >= 1024 && ++l) {
        n = n / 1024;
      }
      return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
    },
    shortText(name) {
      return name.slice(0, 20).concat("...");
    },
    handleFileImport() {
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      e.target.files.forEach((element) => {
        let file_type=""
        let url = null
        let inputFileType = element.name.substr(element.name.indexOf('.') + 1);
        let isAllowed = this.acceptedFileTypes.includes(inputFileType)
        url = URL.createObjectURL(element)
        if (element.type.includes("image")) file_type = "image";
        else if (element.type.includes("pdf")) file_type = "pdf";
        else if (element.type.includes("word")) file_type = "word";
        else if (element.type.includes("sheet")) file_type = "sheet";
        else file_type = "file";
        if(!isAllowed)
          this.countNotAllowedFiles +=1
        else
          this.uploadedFiles.push({url, file_type, isMainDocument: false, file: element})

        if(this.countNotAllowedFiles > 0){
          this.text = `${this.countNotAllowedFiles} file/s was not added. File type not allowed.`
          this.snackbar = true
        }
      })
      document.getElementById('file-input').value= null;
    },
  },
  computed: {
    filteredFiles() {
      if (this.search) {
        return this.uploadedFiles.filter((item) =>
          item.file.name.toLowerCase().includes(this.search.toLowerCase())
        );
      } else return this.uploadedFiles;
    },
    tableHeight() {
      if (this.uploadedFiles.length == 1) return "130px";
      else if (this.uploadedFiles.length == 2) return "200px";
      else return "240px";
    },
  },
  watch: {
    uploadedFiles() {
      this.$emit("addedFiles", this.uploadedFiles);
    },
    doneUploading() {
      if(this.doneUploading)
        this.uploadedFiles = []
    }
  },
};
</script>

<style scoped>
.files-table {
  table-layout: fixed;
}
.v-sheet.v-card {
  border: 2px dashed #1976d2 !important;
  background-color: #f6f6f6;
  border-radius: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: 0px 0px;
}
.v-icon.v-icon {
  color: grey !important;
}
.content-text {
  vertical-align: middle;
}
.content-container {
  margin-top: 70px;
  margin-bottom: 70px;
}

.content-container span {
  vertical-align: middle;
}
</style>